
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "checkFirm",
})
export default class checkFirm extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  
  data() {
        return {
		  url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
		  enable:'启用',
          options1: [{
            value1: '选项1',
            label1: '开业'
          }, {
            value1: '选项2',
            label1: '歇业'
          }],
          value1: '',
        }
    }

  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    let datas = [];
    let pageSize = 20;
    let pageNum = 1;
	let enable = 0;
    let paramter = {
    	'pageSize':pageSize,
    	'pageNum':pageNum,
		'enable':enable
    };
    this.$http.get("shop/list", {params:paramter}).then((res: any) => {
    	datas = res.data.data.data;
    	this.tableData = datas;
    });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
  }
  private userStateChange(enable){
	  
	  // 启用权限
    console.log(enable);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleCheck(id){
  	  
  	  console.log(id);
  	  this.$router.push('/Firm/editFirm/?id='+id)
  }
  private handleDelete(id){
	  
	  console.log(id);
	  // this.$router.push('/User/editBalance/?id='+row.id);
  }
  
}
